import { render, staticRenderFns } from "./MeetingRoomSetup.vue?vue&type=template&id=ea65b322&scoped=true&"
import script from "./MeetingRoomSetup.vue?vue&type=script&lang=js&"
export * from "./MeetingRoomSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea65b322",
  null
  
)

export default component.exports